<template>
  <form @submit.prevent="$emit('submit')">
    <div class="space-y-6 pb-12">
      <div class="overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-gray-950/5">
        <section class="px-6 py-8 sm:px-8">
          <h2 class="mb-5 text-[11px] font-semibold uppercase tracking-wider text-gray-400">
            Nazwa ({{ activeEditingLocale.toUpperCase() }})
          </h2>
          <text-input
            v-model="loc.name"
            :errors="localeErrors('name')"
            class="w-full"
            :required="activeEditingLocale === 'pl'"
            maxlength="100"
          />
        </section>

        <section class="border-t border-gray-100 px-6 py-8 sm:px-8">
          <file-input
            v-model="form.language.image"
            :errors="form.errors['language.image'] || form.errors.image || []"
            class="w-full"
            label="Obrazek (flaga)"
            accept="image/jpeg,image/jpg,image/png,.jpg,.jpeg,.png"
          />
          <div v-if="imageUrl" class="mt-4">
            <label class="form-label">Aktualny obrazek</label>
            <img
              :src="imageUrl"
              alt="Aktualny obrazek"
              class="mt-2 h-12 w-auto rounded object-cover"
            >
          </div>
        </section>

        <section
          v-if="showActiveToggle"
          class="border-t border-gray-100 px-6 py-8 sm:px-8"
        >
          <toggle-switch
            v-model="form.language.active"
            :errors="form.errors['language.active'] || []"
            label="Aktywny"
            description="Widoczny na profilach specjalistów"
          />
        </section>
      </div>
    </div>
    <slot />
  </form>
</template>

<script>
import TextInput from '@/Shared/TextInput.vue';
import FileInput from '@/Shared/FileInput.vue';
import ToggleSwitch from '@/Shared/ToggleSwitch.vue';

export default {
  components: {
    TextInput,
    FileInput,
    ToggleSwitch,
  },
  props: {
    modelValue: {
      type: Object,
      required: true,
    },
    imageUrl: {
      type: String,
      default: null,
    },
    editingLocale: {
      type: String,
      default: undefined,
    },
    showActiveToggle: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['update:modelValue', 'update:editingLocale', 'submit'],
  data() {
    return {
      internalEditingLocale: 'pl',
    };
  },
  computed: {
    form: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      },
    },
    activeEditingLocale: {
      get() {
        return this.editingLocale !== undefined ? this.editingLocale : this.internalEditingLocale;
      },
      set(val) {
        if (this.editingLocale !== undefined) {
          this.$emit('update:editingLocale', val);
        } else {
          this.internalEditingLocale = val;
        }
      },
    },
    loc() {
      return this.form.language[`data_${this.activeEditingLocale}`];
    },
  },
  created() {
    ['data_pl', 'data_en'].forEach((key) => {
      if (!this.form.language[key]) {
        this.form.language[key] = { name: '' };
      }
    });
  },
  methods: {
    localeErrors(field) {
      const errors = this.form.errors || {};
      const raw =
        errors[`language.data_${this.activeEditingLocale}.${field}`] ||
        errors[`language.${field}`] ||
        errors[field];
      if (!raw) return [];
      return Array.isArray(raw) ? raw : [raw];
    },
  },
};
</script>
